/**
 * eslint-disable jsx-a11y/anchor-is-valid
 *
 * @format
 */

/**
 * eslint-disable jsx-a11y/anchor-is-valid
 *
 * @format
 */

/** @format */

import React from "react";
import FilterModal from "./FilterModal";

const SearchReport = ({
  data,
  setSearched,
  setSearch,
  setFilter,
  setExportSkip,

  filterData,
  setModalFilter,
  setClear,
  setShowFilter,
}) => {
  return (
    <div className="mb-4 w-100">
      <div className="row align-items-center g-3">
        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center">
            <div className="search-box" style={{ width: "95%" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search for Fellows"
                onChange={(e) => setSearch(e.target.value)}
                value={data?.search}
              />
            </div>

            {data?.searched ? (
              <button
                className="btn btn-primary me-2 ms-2"
                onClick={() => {
                  setSearch("");
                  setSearched(false);
                  setFilter(`page=1&page_size=100`);
                }}
              >
                Clear
              </button>
            ) : (
              <button
                className="btn btn-outline-light me-2 ms-2"
                onClick={() => {
                  if (data?.search?.length > 0) {
                    // setClear(!clear);
                    setFilter(`page=1&page_size=100&fellow_id=${data?.search}`);
                    // setFiltered(false);
                    setSearched(true);
                  }
                }}
              >
                <i className="bi bi-search"></i>
              </button>
            )}

            <button className="btn btn-outline-light me-2" onClick={() => {
                setShowFilter(true);
            }}>
              <i className="bi bi-filter"></i>
            </button>

            <button
              type="button"
              className="btn btn-outline-light "
              onClick={() => {
                setExportSkip(false);
              }}
            >
              {data?.exporting || data?.isExporting ? (
                <span>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Exporting...
                </span>
              ) : (
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.7">
                      <path
                        d="M20.625 10.4999V19.4999C20.625 19.9972 20.4275 20.4741 20.0758 20.8257C19.7242 21.1774 19.2473 21.3749 18.75 21.3749H5.25C4.75272 21.3749 4.27581 21.1774 3.92417 20.8257C3.57254 20.4741 3.375 19.9972 3.375 19.4999V10.4999C3.375 10.0026 3.57254 9.52572 3.92417 9.17409C4.27581 8.82245 4.75272 8.62491 5.25 8.62491H7.125C7.42337 8.62491 7.70952 8.74344 7.9205 8.95442C8.13147 9.16539 8.25 9.45154 8.25 9.74991C8.25 10.0483 8.13147 10.3344 7.9205 10.5454C7.70952 10.7564 7.42337 10.8749 7.125 10.8749H5.625V19.1249H18.375V10.8749H16.875C16.5766 10.8749 16.2905 10.7564 16.0795 10.5454C15.8685 10.3344 15.75 10.0483 15.75 9.74991C15.75 9.45154 15.8685 9.16539 16.0795 8.95442C16.2905 8.74344 16.5766 8.62491 16.875 8.62491H18.75C19.2473 8.62491 19.7242 8.82245 20.0758 9.17409C20.4275 9.52572 20.625 10.0026 20.625 10.4999ZM9.04594 6.79585L10.875 4.96866V12.7499C10.875 13.0483 10.9935 13.3344 11.2045 13.5454C11.4155 13.7564 11.7016 13.8749 12 13.8749C12.2984 13.8749 12.5845 13.7564 12.7955 13.5454C13.0065 13.3344 13.125 13.0483 13.125 12.7499V4.96866L14.9541 6.79866C15.0587 6.90331 15.1829 6.98632 15.3197 7.04295C15.4564 7.09959 15.6029 7.12874 15.7509 7.12874C15.8989 7.12874 16.0455 7.09959 16.1822 7.04295C16.3189 6.98632 16.4432 6.90331 16.5478 6.79866C16.6525 6.69401 16.7355 6.56978 16.7921 6.43305C16.8487 6.29632 16.8779 6.14978 16.8779 6.00179C16.8779 5.85379 16.8487 5.70725 16.7921 5.57052C16.7355 5.43379 16.6525 5.30956 16.5478 5.20491L12.7978 1.45491C12.6933 1.35003 12.5691 1.26681 12.4324 1.21003C12.2956 1.15325 12.149 1.12402 12.0009 1.12402C11.8529 1.12402 11.7063 1.15325 11.5695 1.21003C11.4328 1.26681 11.3086 1.35003 11.2041 1.45491L7.45406 5.20491C7.34942 5.30956 7.2664 5.43379 7.20977 5.57052C7.15314 5.70725 7.12399 5.85379 7.12399 6.00179C7.12399 6.30067 7.24272 6.58732 7.45406 6.79866C7.66541 7.01 7.95205 7.12874 8.25094 7.12874C8.54982 7.12874 8.83647 7.01 9.04781 6.79866L9.04594 6.79585Z"
                        fill="#2C3E4B"
                      />
                    </g>
                  </svg>
                </span>
              )}
            </button>
          </div>
        </div>
      </div>


      <FilterModal
        setFilter={setModalFilter}
        setShowFilter={setShowFilter}
        showModal={filterData?.showFilter}
        filtering={filterData?.filtering}
        restoreFellows={() => {}}
        clearFilter={data?.clear}
      />
    </div>
  );
};

export default SearchReport;